import * as React from 'react';
import { ActionButton, fetchApi, notifyError, notifyResponse } from 'gossamer-front-end';
import { AdminOrgUnitMemberRemoveRequest, OrgUnitMember, OrgUnitMemberView } from 'cb-model';

export interface RemoveMemberFromOrgUnitButtonProps {
  value: string; // org unit member id
}

export const RemoveMemberFromOrgUnitButton: React.FC<RemoveMemberFromOrgUnitButtonProps> = (props) => {
  return (
    <ActionButton
      label="Remove"
      size="sm"
      variant="danger"
      execute={async (resetCache) => {
        try {
          const response = await fetchApi('POST', `/main/org-unit-member-remove`, {
            orgUnitMemberId: Number(props.value),
          } as AdminOrgUnitMemberRemoveRequest);
          resetCache(OrgUnitMember.id, props.value);
          resetCache(OrgUnitMemberView.id, props.value);
          notifyResponse(response);
        } catch (e) {
          notifyError(e, 'An error occurred while removing the member from the group');
        }
      }}
    />
  );
};
